module.exports = __webpack_public_path__ + "static/media/mongo_db_logo.701abb78.png";